import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { axios } from '@utils/lib';
import { Enums, Paths } from '@utils/constants';

export const getCharts = createAsyncThunk(
  'api/get-charts',
  async (query: GetChartsQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const params = new URLSearchParams({
      startDate: query.startDate,
      endDate: query.endDate,
    }).toString();
    try {
      const { data } = await axios.request<GetChartsRes>(
        Enums.HTTP_METHOD.GET,
        Paths.GET_CHARTS + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getFaceIdsChart = createAsyncThunk(
  'api/get-face-ids-chart',
  async (query: GetChartsQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const params = new URLSearchParams({
      startDate: query.startDate ?? '',
      endDate: query.endDate ?? '',
    }).toString();
    try {
      const { data } = await axios.request<IListRes<FaceIdChartData>>(
        Enums.HTTP_METHOD.GET,
        Paths.GET_FACE_IDS_CHART + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
